import React from 'react';
interface LeftSwipperArrowsProps {
  isFirstSlide: boolean;
}
interface RightSwipperArrowsProps {
  isLastSlide: boolean;
}
export const LeftSwipperArrows = ({ isFirstSlide }: LeftSwipperArrowsProps) => {
  return (
    <div>
      {isFirstSlide ? (
        <svg
          width="30"
          height="31"
          viewBox="0 0 30 31"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="-0.5"
            y="0.5"
            width="29"
            height="29"
            rx="14.5"
            transform="matrix(-1 0 0 1 29 0.5)"
            stroke="#AAAAAA"
          />
          <path
            d="M13.1797 10.9492L8.62719 15.5017L13.1797 20.0542"
            stroke="#AAAAAA"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M21.375 15.5H8.7525"
            stroke="#AAAAAA"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="31"
          height="31"
          viewBox="0 0 31 31"
          fill="none"
        >
          <circle cx="15.5" cy="15.5" r="15.5" fill="#1F2C5B" />
          <path
            d="M9.29289 14.2929C8.90237 14.6834 8.90237 15.3166 9.29289 15.7071L15.6569 22.0711C16.0474 22.4616 16.6805 22.4616 17.0711 22.0711C17.4616 21.6805 17.4616 21.0474 17.0711 20.6569L11.4142 15L17.0711 9.34315C17.4616 8.95262 17.4616 8.31946 17.0711 7.92893C16.6805 7.53841 16.0474 7.53841 15.6569 7.92893L9.29289 14.2929ZM21 14L10 14L10 16L21 16L21 14Z"
            fill="white"
          />
        </svg>
      )}
    </div>
  );
};
export const RightSwipperArrows = ({
  isLastSlide
}: RightSwipperArrowsProps) => {
  return (
    <div>
      {isLastSlide ? (
        <svg
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.5"
            y="0.5"
            width="29"
            height="29"
            rx="14.5"
            stroke="#AAAAAA"
          />
          <path
            d="M16.8203 10.4492L21.3728 15.0017L16.8203 19.5542"
            stroke="#AAAAAA"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M8.625 15H21.2475"
            stroke="#AAAAAA"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="31"
          height="31"
          viewBox="0 0 31 31"
          fill="none"
        >
          <circle cx="15.5" cy="15.5" r="15.5" fill="#1F2C5B" />
          <path
            d="M21.7071 15.7071C22.0976 15.3166 22.0976 14.6834 21.7071 14.2929L15.3431 7.92893C14.9526 7.53841 14.3195 7.53841 13.9289 7.92893C13.5384 8.31946 13.5384 8.95262 13.9289 9.34315L19.5858 15L13.9289 20.6569C13.5384 21.0474 13.5384 21.6805 13.9289 22.0711C14.3195 22.4616 14.9526 22.4616 15.3431 22.0711L21.7071 15.7071ZM10 16H21V14H10V16Z"
            fill="white"
          />
        </svg>
      )}
    </div>
  );
};
